import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import * as translationFR from './locales/fr';
import * as translationEN from './locales/en';

const convertToTranslationObject = (translations: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {};
  
  Object.entries(translations).forEach(([key, value]) => {
    if (key !== '__esModule') { // Ignorer la propriété __esModule
      result[key] = value;
    }
  });
  
  return result;
};

// Les ressources contenant les traductions
const resources = {
  fr: {
    translation: convertToTranslationObject(translationFR)
  },
  en: {
    translation: convertToTranslationObject(translationEN)
  }
};

i18n
  // Charge les traductions via http (i18next-http-backend)
  .use(HttpBackend)
  // Détecte la langue du navigateur
  .use(LanguageDetector)
  // Passe l'instance i18n à react-i18next
  .use(initReactI18next)
  // Initialise i18next
  .init({
    resources,
    fallbackLng: 'fr', // Langue par défaut si la langue détectée n'est pas disponible
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false // React échappe déjà les valeurs
    },
    // Définir les langues supportées
    supportedLngs: ['fr', 'en'],
    // Configurer la détection de langue
    detection: {
      // Ajouter 'path' comme première méthode de détection
      order: ['path', 'localStorage', 'navigator'],
      // Configurer la détection par chemin d'URL
      lookupFromPathIndex: 0,
      caches: ['localStorage']
    }
  });

  // Fonction pour vérifier si une langue est supportée et rediriger si nécessaire
  const checkLanguageAndRedirect = (lng: string) => {
    const supportedLngs = i18n.options.supportedLngs;
    if (Array.isArray(supportedLngs) && !supportedLngs.includes(lng)) {
      // Si non supportée, revenir à la langue par défaut
      const fallbackLng = i18n.options.fallbackLng as string;
      
      // Récupérer le chemin actuel et remplacer la langue non supportée
      const currentPath = window.location.pathname;
      const pathParts = currentPath.split('/');
      
      // Si le premier segment est une langue (2 caractères)
      if (pathParts[1] && pathParts[1].length === 2) {
        // Remplacer par la langue par défaut
        pathParts[1] = fallbackLng;
        const newPath = pathParts.join('/');
        window.history.replaceState(null, '', newPath);
      }
      
      // Changer la langue dans i18n
      i18n.changeLanguage(fallbackLng);
      return true; // Indique qu'une redirection a eu lieu
    }
    return false; // Pas de redirection nécessaire
  };
  
  // Vérifier la langue au chargement initial de la page
  const currentPath = window.location.pathname;
  const langMatch = currentPath.match(/^\/([a-z]{2})/);
  if (langMatch) {
    const urlLang = langMatch[1];
    checkLanguageAndRedirect(urlLang);
  }
  
  // Vérifier également lors des changements de langue
  i18n.on('languageChanged', (lng) => {
    checkLanguageAndRedirect(lng);
  });

export default i18n;
